function GameDeadlineTitle(currDeadline, activePage) {
    let bannerTitle = '';

    if(currDeadline === 'tnf') {
        bannerTitle = 'Thursday Night';
    } else if(currDeadline === 'christmas_normal'){
        bannerTitle = 'Wednesday - Chirstmas Early Afternoon';
    } else if(currDeadline === 'christmas_normal_afternoon'){
        bannerTitle = 'Wednesday - Chirstmas Late Afternoon';
    } else if(currDeadline === 'christmas_normal_night'){
        bannerTitle = 'Wednesday - Chirstmas Night';                
    } else if(currDeadline === 'saturday_morning'){
        bannerTitle = 'Saturday Early Afternoon';
    } else if(currDeadline === 'saturday_afternoon'){ // TODO: improve saturday logic for next year
        bannerTitle = 'Saturday Late Afternoon';
    } else if(currDeadline === 'saturday_night'){
        bannerTitle = 'Saturday Night';
    } else if(currDeadline === 'normal_afternoon'){
        bannerTitle = 'Sunday Late Afternoon';
    } else if(currDeadline === 'normal_night'){
        bannerTitle = 'Sunday Night';
    } else if(currDeadline === 'mnf'){
        bannerTitle = 'Monday';
    } else if(currDeadline === 'london'){
        bannerTitle = 'Sunday AM in London';
    } else if(currDeadline === 'thanksgiving_morning') {
        bannerTitle = 'Thanksgiving Morning';
    } else if(currDeadline === 'thanksgiving_afternoon') {
        bannerTitle = 'Thanksgiving Afternoon';
    } else if(currDeadline === 'thanksgiving_night') {
        bannerTitle = 'Thanksgiving Night';
    } else if(currDeadline === 'christmas_morning') {
        bannerTitle = 'Christmas Morning';
    } else if(currDeadline === 'christmas_afternoon') {
        bannerTitle = 'Christmas Afternoon';
    } else if(currDeadline === 'christmas_night') {
        bannerTitle = 'Christmas Night';
    } 
    else if(currDeadline === 'black_friday') {
        bannerTitle = 'Black Friday';
    } else if(currDeadline === 'friday_night') {
        bannerTitle = 'Friday Night';
    } else {
        bannerTitle = 'Sunday Early Afternoon';
    }

    

    return bannerTitle;
}

export default GameDeadlineTitle;